// extracted by mini-css-extract-plugin
export default {"tabs":"FeedsTabs-tabs"};